module.exports = __webpack_public_path__ + "static/media/placement.f4573e3b.svg";